export default "__VITE_ASSET__DAPYFJdF__"